export enum UserEvents {
    PlayerConnected = 'playerConnected',
    GetTerrain = 'getTerrain',
    GotTerrain = 'gotTerrain',
    GetOres = 'getOres',
    GotOres = 'gotOres',
    GetSync = "getSync",
    GotSync = "gotSync",
    GotTicks = 'gotTicks',
    Attack = 'attack',
    ChatMessage = 'chatMessage',
    SpawnWorker = "spawnWorker",
    SpawnTank = "spawnTank",
    SpawnBuilding = "spawnBuilding"
}
